﻿export class Project {
  constructor() {
    this.userMenuWrapperSelector = ".ele-user-menu";
    this.userMenuToggleSelector = ".user-menu-toggle";
    
    this.userMenuWrapper = document.querySelector(this.userMenuWrapperSelector);
    if(this.userMenuWrapper) {
      this.attachEventListener();
    }
  }

  attachEventListener() {
    let menuList = this.userMenuWrapper.querySelector("ul");

    document.addEventListener("click", e => {
      if(e.target.closest(this.userMenuToggleSelector)) {
        menuList.style.display = menuList.style.display === "none" ? "block" : "none";
      }
      if(!e.target.closest(this.userMenuWrapperSelector)) {
        if(menuList.style.display === "block") {
          menuList.style.display = "none";
        }
      }
    });
  }


}

new Project();

// var ignore_onbeforeunload = false;

// $(window).on('beforeunload', function(e){
//   if (!ignore_onbeforeunload){
//       $('body').addClass('wait');
//   }
//   ignore_onbeforeunload = false;
// });
  




// $(document).on('ajaxSuccess',function(e){
//   $(".text-edit").each(function(){
//     console.log($(this).data("key"));
//   });

// // $('document').on('click','#saldoc-comment',function(e){
//     // $(this).donetyping(function(){
//     //   var url = $('#asyn-checkout-saldoc-comment').data('url');
//     //   $.ajax({
//     //     type: 'POST',
//     //     url: url,
//     //     data:{
//     //       comment: $(this).val()
//     //     }
//     //   }).done(function(data) {
//     //   });
//     // });
  
// });  



// $(document).ready(function(){
  
//   $(".text-edit").each(function(){
//     sessionStorage.setItem($(this).data("key"),$(this).data("key"));
//   });
  


  

//   $(document).on("DOMNodeInserted",function() {
//     $(".text-edit").each(function(){
//       sessionStorage.setItem($(this).data("key"),$(this).data("key"));
//     });

//   });

// })



// function getStorageItems(){
//   for (var i = 0; i < sessionStorage.length; i++){
//     console.log(sessionStorage.getItem(sessionStorage.key(i)));
//   }
// }
  
//   $('.text-edit').on('contextmenu',function(e){
//     $(this).append("<input class='inline-text-editor' style='width:100%' data-orig-text=\""+$(this).text()+"\" type=\"text\" value=\""+$(this).text()+"\"><button onclick='saveTextItem(this)'>save</button>");
//   });
